// Copyright ©️ 2026 eVolve MEP, LLC

import type { CSSVariablesResolver } from '@mantine/core';

export const EVOLVEICON_SIZE_PREFIX = 'eicon-size';

export const variableResolver: CSSVariablesResolver = (_theme) => ({
  variables: {
    /** Used for EvolveIcon component */
    [`--${EVOLVEICON_SIZE_PREFIX}-xs`]: '12px',
    [`--${EVOLVEICON_SIZE_PREFIX}-sm`]: '18px',
    [`--${EVOLVEICON_SIZE_PREFIX}-md`]: '24px',
    [`--${EVOLVEICON_SIZE_PREFIX}-lg`]: '32px',
    [`--${EVOLVEICON_SIZE_PREFIX}-xl`]: '40px',
  },
  light: {},
  dark: {},
});
